export const typeDefs = `
  input ViewerInputMutation {
    src: String
    withdrawalBTCAddress: String
  }

  input AuthenticateUserInputMutation {
    id_token: String
    access_token: String
    refresh_token: String
  }
`;
